<template>
  <div
    v-if="isShow"
    class="swiper-slide"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SwiperSlide',
  data() {
    return {
      index: this.$parent.$children.indexOf(this),
      recycle: this.$parent.recycle,
      showNum: this.$parent.showNum,
      isRow: this.$parent.isRow,
    };
  },
  computed: {
    current() {
      return this.$parent.slideIndex;
    },
    isShow() {
      const isShow = !this.recycle
          || (
            (this.current >= this.index - Math.floor(this.showNum / 2))
              && (this.current < this.index + Math.ceil(this.showNum / 2)
              )
          );
      return isShow;
    },
  },
  watch: {
    isShow(newV) {
      // 仅支持满屏
      const width = this.getFullWidth();
      const height = this.$parent.swiperHeight;
      if (newV && this.index < this.current) {
        // 左/上侧元素重新呈现
        this.$parent.$emit('updatePadding', this.isRow ? -width : -height);
      } else if (!newV && this.index < this.current) {
        // 左/上侧元素隐藏
        this.$parent.$emit('updatePadding', this.isRow ? width : height);
      }
    },
  },
  mounted() {
    // 初始状态设定
    const width = this.getFullWidth();
    const height = this.$parent.swiperHeight;
    if (!this.isShow && this.index < this.current) {
      // 左/上侧元素隐藏
      this.$parent.$emit('updatePadding', this.isRow ? width : height);
    }
  },
  methods: {
  },
};
</script>

<style>
  .swiper-slide {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }
</style>
